// extracted by mini-css-extract-plugin
export default {"pageWrap":"Za-z","fullWidth":"_a-z","heading":"ab-z","fullBleed":"bb-z","hidden":"cb-z"};